/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alarms_Status_InactiveInputs */



/**
* | output |
* | --- |
* | "Inactive alarms" |
*
* @param {Alarms_Status_InactiveInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const alarms_status_inactive = /** @type {((inputs?: Alarms_Status_InactiveInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Status_InactiveInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Inactive alarms")
	return /** @type {LocalizedString} */ ("Alarmes non surveillées")
});